export class AuthApi {

    static url = {
        login: `oauth/token`,
        loginWeb: `user/loginWeb`,
        verifyotp: `user/verifyotp`,
        clearSession: `user/delete-existing-session`,
        user_status_check: `user/user_status_check`,
        partner_authorization: `user/partner_authorization`,
        dashboard: `user/dashboard`,
        logout: `logout`,
        fetch_customer_balance: `cms/fetch_customer_balance`,
        userdetails: `user/profile_details_fetch`,
        selfsignup: `user/self_signup`,
        resend_otp: `user/resend_otp_generation`,
        login1st_verifyotp: `user/verify_self_signup`
    };
}